import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { ConvertHelper } from '../../../../helper/convert.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import {
  ICompanyContacts,
  IContact,
  LeadComposerChangesModel,
  SelectedComposerOffers
} from "../../../../models/leads/leads.model";
import { LeadHelper } from '../../../../helper/lead.helper';
import { CurrencyHelper } from '../../../../helper/app-currency';
import { UserTokenService } from '../../../../services/user-service/user-token.service';

@Component({
  selector: 'fi-place-in-order',
  templateUrl: './place-in-order-popup.component.html',
  styleUrls: ['./place-in-order-popup.component.scss'],
  standalone: false,
})
export class PlaceInOrderPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('ORDER_PLACED', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('ORDER_PLACED', true);
  submitting: boolean;
  companyContacts: ICompanyContacts[];
  contactToDisplay: IContact;
  leadOfferId = [LeadHelper.LEAD_OFFER_ID, LeadHelper.LEAD_EVENT_ID];
  leadTypeId: number;
  currencies = CurrencyHelper.FINSTRAL_CURRENCIES;
  extendedProperties = {
    ORDER_AMOUNT: null,
    ORDER_CURRENCY: '',
    ORDER_NUMBER: null,
  };
  placeInOrder = {
    Comment: '',
    CustomerCode: '',
    CustomerCodeComposer: ''
  };
  inValidNote = false;
  inValidNumber = false;
  composerOrders: LeadComposerChangesModel[] = [];
  loadedLeadComposerOffers: LeadComposerChangesModel[];
  checkedComposerOffers: SelectedComposerOffers = {};
  isExternal: boolean;

  constructor(
    public dialogRef: MatDialogRef<PlaceInOrderPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, externalEmail: string,isExternal: boolean, loadedLeadComposerOffers: LeadComposerChangesModel[]},
    private userTokenService: UserTokenService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {
    super(dialogRef);
    this.extendedProperties.ORDER_CURRENCY = this.userTokenService.getCurrency() ?? CurrencyHelper.DEFAULT_CURRENCY;

    if (dialogData?.loadedLeadComposerOffers?.length) {
      this.loadedLeadComposerOffers = dialogData.loadedLeadComposerOffers;
      this.getOrdersAndOffersFromComposer(this.loadedLeadComposerOffers);
      this.checkComposerDataByDefault(this.loadedLeadComposerOffers);
    }

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.leadTypeId = dialogData?.leadTypeId;
    this.isExternal = this.dialogData?.isExternal;

    if (!dialogData?.loadedLeadComposerOffers) {
      leadsDataService.getLeadComposerOffers(this.leadId).subscribe(( { success, data } ) => {
        if ( success ) {
          this.loadedLeadComposerOffers = data;
          this.getOrdersAndOffersFromComposer(this.loadedLeadComposerOffers);
          this.checkComposerDataByDefault(this.loadedLeadComposerOffers);
        }
      });
    }

    if (this.isExternal) {
      this.darkIconUrl = ActionIconHelper.getActionIconUrl('ORDER_PLACED_EXTERNAL', true);
    }


    this.leadsDataService.getLeadById(this.leadId).subscribe(({ success, data }) => {
      if (success) {
        this.placeInOrder.CustomerCode = data.Contact?.CustomerCode;
        this.placeInOrder.CustomerCodeComposer = data.Contact?.CustomerCodeComposer;
        this.companyContacts = data.CompanyContacts;
        this.contactToDisplay = data.Contact;
      }
    });
  }

  ngOnInit(): void {
  }

  private getOrdersAndOffersFromComposer(items: LeadComposerChangesModel[]): void {
    this.composerOrders = [];
    items.forEach(item => {
      if (item.IsOrder) {
        this.composerOrders.push(item);
      }
    })
  }

  addOrRemoveOffer(offer: LeadComposerChangesModel): void {
    let keys = Object.keys(this.checkedComposerOffers);
    let exists = keys.findIndex(item => item === offer.Name);

    if (this.checkedComposerOffers[keys[exists]]) {
      this.checkedComposerOffers[keys[exists]] = false;
    } else {
      this.checkedComposerOffers[keys[exists]] = true;
    }
  }

  private checkComposerDataByDefault(loadedLeadComposerOffers: LeadComposerChangesModel[]): void {
    loadedLeadComposerOffers?.forEach(offer => {
      this.checkedComposerOffers[offer.Name] = true;
    })
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.leadId && !this.submitting && !this.inValidNote && !this.inValidNumber;
  }

  setExtendedProperties(currency: string): void {
    this.currencies.forEach(el => {
      if (el.Id.toString() === currency) {
        this.extendedProperties.ORDER_CURRENCY = el.Description;
      }
    })
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.placeInOrder.Comment.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;
      if (!!this.extendedProperties.ORDER_AMOUNT && !Number.isNaN(this.extendedProperties.ORDER_AMOUNT)) {
        this.extendedProperties.ORDER_AMOUNT = ConvertHelper.currencyToNumber(this.extendedProperties.ORDER_AMOUNT);
      }
      this.actionDataService.placeOrder(this.leadId, this.placeInOrder, !!this.dialogData.isExternal)
        .subscribe(({
                      success,
                      data
                    }) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove');
          }

          this.submitting = false;
        });
    }
  }

  isNotNumber(): boolean {
    const regex = new RegExp(/^\d[\d,.]*\d$/);
    let number = this.extendedProperties.ORDER_AMOUNT;
    if (number) {
      if (typeof number === 'string' && regex.test(number)) {
        if (number[0] == '0' && (number[1] != ',' && number[1] != '.')) {
          this.inValidNumber = true;
        } else {
          this.inValidNumber = false;
        }
      } else if (typeof number === 'number' && !isNaN(number)) {
        this.inValidNumber = false;
      } else {
        if ((number + '').length === 1 && !isNaN(number)) {
          this.inValidNumber = false;
        } else {
          this.inValidNumber = true;
        }
      }
      return this.inValidNumber;
    }
    return this.inValidNumber;
  }
}


